import React from "react";
import Images from "../../constant/Images";
import { IoCalendarOutline } from "react-icons/io5";
import { BiCalendarEvent } from "react-icons/bi";
import { RiTimerLine } from "react-icons/ri";
import { GiTimeTrap } from "react-icons/gi";
import { PiNotepad } from "react-icons/pi";
import { MdOutlineSpeakerNotes } from "react-icons/md";
import { GiSandsOfTime } from "react-icons/gi";
import SchedulerStatus from "../../Enum/SchedulerStatus";
const MeetingInfo = ({ setVisibleHistory, setVisible, meeting }) => {
  const status = SchedulerStatus.find((list) => list.value === meeting?.status);
  return (
    <div className="flex flex-col gap-4 font-inter text-">
 

      <div className="flex mt-3  justify-start  gap-3">
        <IoCalendarOutline className="text-2xl text-primary" />
        <div className="text-[20px]  text-gray-600 font-inter ">
          {meeting?.title || "Null"}
        </div>
      </div>

      <div className="flex flex-col gap-2 text-gray-600">
        <div>Meeting Person: {meeting?.contactPerson}</div>
        <div>Meeting Place: {meeting?.meetingPlace || ""}</div>
      </div>

        <div className="flex flex-col gap-2 text-gray-600">
        <div className="flex gap-1"><span className="shrink-0">Meeting Incharge:</span><span title={meeting?.meetingIncharge} className="line-clamp-3 break-words overflow-hidden max-w-[260px]">{meeting?.meetingIncharge || "-"}</span></div>
        {/* <div>Meeting Place: {meeting?.meetingPlace || ""}</div> */}
      </div>

      <div className="flex flex-col gap-2 text-gray-600">
        <div className="flex gap-1"><span className="shrink-0">Initial Meeting Information Medium:</span><span title={meeting?.initialMeetingInformationMedium} className="line-clamp-3 break-words overflow-hidden max-w-[260px]">{meeting?.initialMeetingInformationMedium || "-"}</span></div>
        <div className="flex gap-1"><span className="shrink-0">Final Meeting Information Medium:</span><span title={meeting?.finalMeetingInformationMedium} className="line-clamp-3 break-words overflow-hidden max-w-[260px]">{meeting?.finalMeetingInformationMedium || "-"}</span></div>
      </div>

      <div className="flex flex-wrap gap-5">
        <div className="bg-green-50 flex text-gray-600 items-center gap-2 text-xs border border-green-500 rounded-full px-2 py-1 w-fit">
          <BiCalendarEvent className="text-green-500 text-base" />
          <div>Date:{meeting?.meetingDate.replace(/\//g, "-")}</div>
        </div>

        <div className="bg-violet-50 flex text-gray-600 items-center gap-2 text-xs border border-violet-500 rounded-full px-2 py-1 w-fit">
          <RiTimerLine className="text-violet-500 text-base" />
          <div>Timing: {meeting?.meetingDuration}</div>
        </div>

        <div className="bg-orange-50 flex text-gray-600 items-center gap-2 text-xs border border-orange-500 rounded-full px-2 py-1 w-fit">
          <GiSandsOfTime className="text-orange-500 text-base" />
          <div>Duration: {meeting?.durationInMinutes} Min</div>
        </div>
      </div>

      <div className="text-gray-600 mt-5">
        Meeting Status: {status?.label || "Not Available"}
      </div>

      <div className="text-primary  flex items-center gap-2 font-medium">
        <MdOutlineSpeakerNotes  className="text-xl" />
        <div>Meeting Description</div>
        </div>

      <div className="text-gray-600 p-4 border border-slate-200 rounded-[10px]">
        {meeting?.meetingDescription}
      </div>

      {meeting?.closureNotes && (
        <>
          <div className="text-orange-500 gap-2 flex items-center font-medium ">
            <PiNotepad className="text-xl" />
            <div> Notes</div>
          </div>

          <div className="text-gray-600 p-4 border border-slate-200 rounded-[10px]">
            {meeting?.closureNotes}
          </div>
        </>
      )}

      {/* <div className="text-primary font-medium">Reason for Reschedule</div>

      <div className="text-gray-600 p-4 border border-slate-200 rounded-[10px]">
        This meeting is scheduled to review and discuss the current status of
        all leads in the CRM, including their respective stages and ongoing
        deals.
      </div> */}
    </div>
  );
};

export default MeetingInfo;
